import SetAnimationSpeed from './SetAnimationSpeed';

export default {
  __init__: [
    'setAnimationSpeed'
  ],
  setAnimationSpeed: [ 'type', SetAnimationSpeed ]
};